import { Persona } from "../entities/persona";
import { Prestacion } from "../entities/prestacion";
import { PrestacionHistorico } from "../entities/prestacionHistorico";
import { PrestacionReferencia } from "../entities/prestacionReferencia";
import { PrestacionPreparacion } from "../entities/prestaciónPreparación";
import { Protocolo } from "../entities/protocolo";
import { ProtocoloDetalle } from "../entities/ProtocoloDetalle";
import { ProtocoloApi } from "../interfaces/protocoloApi";

export class ProtocoloService {
  constructor(private protocoloApi: ProtocoloApi) {}

  public async getProtocolos(
    startDate: string,
    endDate: string,
    token: string
  ): Promise<Protocolo[]> {
    return await this.protocoloApi.getProtocolos(startDate, endDate, token);
  }

  public async getProtocoloDetalle(
    ordenDeTrabajo: number,
    token: string
  ): Promise<ProtocoloDetalle[]> {
    return await this.protocoloApi.getProtocoloDetalle(ordenDeTrabajo, token);
  }

  public async getProtocoloInforme(
    ordenDeTrabajo: number,
    token: string
  ): Promise<string> {
    return await this.protocoloApi.getProtocoloInforme(ordenDeTrabajo, token);
  }

  public async getPrestaciones(token: string): Promise<Prestacion[]> {
    return await this.protocoloApi.getPrestaciones(token);
  }

  public async getPrestacionReferencia(
    idPrestación: number,
    token: string
  ): Promise<PrestacionReferencia[]> {
    return await this.protocoloApi.getPrestacionReferencia(idPrestación, token);
  }

  public async getPrestacionPreparacion(
    idPrestación: number,
    token: string
  ): Promise<PrestacionPreparacion[]> {
    return await this.protocoloApi.getPrestacionPreparacion(
      idPrestación,
      token
    );
  }
  public async getPersona(token: string): Promise<Persona> {
    return await this.protocoloApi.getPersona(token);
  }

  public async getPrestacionHistorico(
    ordenDeTrabajo: number,
    token: string
  ): Promise<PrestacionHistorico[]> {
    return await this.protocoloApi.getPrestacionHistorico(
      ordenDeTrabajo,
      token
    );
  }
}
